import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { toggleIncidentModals,
    openCreateIncident,
    deleteAffectedEntities,
    toggleEditEffectPanel,
    updateDisruptionKeyToEditEffect,
    toggleWorkaroundPanel,
    updateDisruptionKeyToWorkaroundEdit,
    setDisruptionForWorkaroundEdit,
    updateCurrentStep,
    updateEditMode,
} from '../../../../../redux/actions/control/incidents';
import { isModalOpen } from '../../../../../redux/selectors/activity';
import { getEditMode } from '../../../../../redux/selectors/control/incidents';
import EDIT_TYPE from '../../../../../types/edit-types';

const Cancellation = (props) => {
    const closeCreateIncident = () => {
        if (props.editMode === EDIT_TYPE.ADD_EFFECT) {
            props.clearNewEffectToIncident();
            props.updateEditMode(EDIT_TYPE.EDIT);
            props.updateCurrentStep(1);
            props.toggleIncidentModals('isCancellationOpen', false);
        } else {
            props.openCreateIncident(false);
            props.deleteAffectedEntities();
            props.toggleIncidentModals('isCancellationOpen', false);
            props.toggleEditEffectPanel(false);
            props.updateDisruptionKeyToEditEffect('');
        }
        props.toggleWorkaroundPanel(false);
        props.updateDisruptionKeyToWorkaroundEdit('');
        props.setDisruptionForWorkaroundEdit({});
    };
    return (

        <div className="disruption-creation__wizard-confirmation">
            <div className="row">
                <div className="col 'd-flex justify-content-center'">
                    <h2>Are you sure you want to close?</h2>
                    <div>
                        <span className="d-block mt-3 mb-2">Any information entered will not be saved.</span>
                    </div>
                </div>
            </div>
            <footer className="row justify-content-between mt-3">
                <div className="col-5">
                    <Button
                        className="btn cc-btn-secondary btn-block"
                        onClick={ () => props.toggleIncidentModals('isCancellationOpen', false) }>
                        Keep editing
                    </Button>
                </div>
                <div className="col-5">
                    <Button
                        className="btn cc-btn-primary btn-block"
                        onClick={ () => { closeCreateIncident(); } }>
                        Discard changes
                    </Button>
                </div>
            </footer>
        </div>
    );
};

Cancellation.propTypes = {
    toggleIncidentModals: PropTypes.func.isRequired,
    openCreateIncident: PropTypes.func.isRequired,
    deleteAffectedEntities: PropTypes.func.isRequired,
    toggleEditEffectPanel: PropTypes.func.isRequired,
    toggleWorkaroundPanel: PropTypes.func.isRequired,
    updateDisruptionKeyToEditEffect: PropTypes.func.isRequired,
    updateDisruptionKeyToWorkaroundEdit: PropTypes.func.isRequired,
    setDisruptionForWorkaroundEdit: PropTypes.func.isRequired,
    editMode: PropTypes.string,
    updateCurrentStep: PropTypes.func.isRequired,
    updateEditMode: PropTypes.func.isRequired,
    clearNewEffectToIncident: PropTypes.func,
};

Cancellation.defaultProps = {
    editMode: EDIT_TYPE.CREATE,
    clearNewEffectToIncident: () => { },
};

export default connect(state => ({
    isModalOpen: isModalOpen(state),
    editMode: getEditMode(state),
}), { toggleIncidentModals,
    openCreateIncident,
    deleteAffectedEntities,
    toggleEditEffectPanel,
    updateDisruptionKeyToEditEffect,
    toggleWorkaroundPanel,
    updateDisruptionKeyToWorkaroundEdit,
    setDisruptionForWorkaroundEdit,
    updateCurrentStep,
    updateEditMode,
})(Cancellation);
